export const PRESET_COLORS = [
  { fill: '#F3F4F6', border: '#D1D5DB' },
  { fill: '#EFF6FF', border: '#93C5FD' },
  { fill: '#EEF2FF', border: '#A5B4FC' },
  { fill: '#F5F3FF', border: '#C4B5FD' },
  { fill: '#FFFBEB', border: '#F59E0B' },
  { fill: '#ECFDF5', border: '#6EE7B7' },
  { fill: '#FEF2F2', border: '#FCA5A5' },
  { fill: '#FFF7ED', border: '#FDBA74' },
  { fill: '#ECFEFF', border: '#67E8F9' },
] as const;

export const getViewModalHeaderTitle = (customTitle?: string) => {
  const headerTitle = customTitle || 'New Category';
  const date = new Date();

  const ordinal = (n) => {
    if (n % 100 >= 11 && n % 100 <= 13) {
      return `${n}th`;
    }

    switch (n % 10) {
      case 1:
        return `${n}st`;
      case 2:
        return `${n}nd`;
      case 3:
        return `${n}rd`;
      default:
        return `${n}th`;
    }
  };

  const day = ordinal(date.getDate());
  const month = date.toLocaleString('en-US', { month: 'short' });
  const pad = (n: number) => String(n).padStart(2, '0');
  const time = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds(),
  )}`;

  return `${headerTitle} - ${day} ${month} ${time}`;
};
